import { MutationTree } from 'vuex';
import { DashboardState } from './types';

export const mutations: MutationTree<DashboardState> = {
    setRemindersData(state, payload: any) {
        state.data.reminders = payload;
        state.remindersLoading = false;
    },
    setRemindersError(state, error: any) {
        state.remindersError = true;
        state.data.reminders = undefined;
        state.remindersLoading = false;
    },
    setRemindersLoading(state) {
        state.remindersLoading = true;
    },
    setUsers(state, payload: any) {
        state.data.users = payload.data;
    },
};
